/* eslint-disable no-useless-catch */
import axios from 'axios';
import { getCookie, cookies } from '../utils/common/cookies';

export async function getClaimsData() {
  const requestBody = {
    query: `
        query {
          getClaims {
            claimId,
            digitalFNOLStatus,
            expiresOn,
            createdOn,
            lastUpdatedOn,
            gwClaimId,
            assisted,
            locked,
            gwClaimNumber,
            submittedData,
            lang,
            cdsClaimNumber,
            metadata,
            audatargetClaimId,
            claimServices,
            lossDetailsConfirmed,
            submittedDataGW
        }
    }`,
    queryName: 'get_draft_claims',
  };
  const response = await axios.post('/api', requestBody);
  return response.data;
}

export async function getGWClaims() {
  const requestBody = {
    query: `
        query {
          getGWClaims {
            gwClaimStatus,
            gwClaimId,
            gwClaimNumber,
            lossDate,
            insuredVehicle,
            lossLocation,
            lossScenarioLevel1,
            cdsClaimNumber,
            adjusterDetails
        }
    }`,
    queryName: 'get_gw_claims',
  };
  const response = await axios.post('/api', requestBody);
  return response.data;
}

export async function createClaim(lang) {
  const requestBody = {
    query: `
    mutation {
      createClaim(createClaimInput: {
        lang: "${lang}",
        claimSupportId: "${getCookie(cookies.claimSupportId)}"
      })
      {
        claimId,
        digitalFNOLStatus,
        createdOn,
        lastUpdatedOn,
        expiresOn,
        assisted,
        locked
        gwClaimId,
        gwClaimNumber,
        submittedData,
        submittedDataGW,
      }
    }`,
    queryName: 'create_claim',
  };
  const response = await axios.post('/api', requestBody);
  return response.data;
}

export async function updateClaim(claimId, status, submissionData, submissionDataGW, isUpdateToGwRequired, lang, metadata, lossDetailsConfirmed) {
  const requestBody = {
    query: `
      mutation {
        updateClaim(updateClaimInput:
          {
            claimId: "${claimId}",
            digitalFNOLStatus: "${status}",
            submittedData: """${submissionData}""",
            submittedDataGW: """${submissionDataGW}""",
            isUpdateToGwRequired: ${isUpdateToGwRequired},
            userIP: "${window.sessionStorage.getItem('userIP')}",
            lang: "${lang}",
            metadata: "${metadata}",
            lossDetailsConfirmed: ${lossDetailsConfirmed},
            claimSupportId: "${getCookie(cookies.claimSupportId)}"
          }
        )
        { claimId, digitalFNOLStatus, submittedData, submittedDataGW, claimNumber, claimServices, 
          cdsClaimNumber, idMapping, audatargetClaimId, lossDetailsConfirmed, claimSupportId }
      }`,
    queryName: 'update_claim',
  };
  // { claimId, digitalFNOLStatus, submittedData, submittedDataGW, }
  const response = await axios.post('/api', requestBody);

  return response;
}

export async function submitClaim(claimId) {
  const requestBody = {
    query: `
      mutation {
        submitClaim(submitClaimInput:
          {
            claimId: "${claimId}",
          }
        )
        { claimId, submitted }
      }`,
    queryName: 'submit_claim',
  };
  const response = await axios.post('/api', requestBody);
  return response.data;
}

export async function createShellClaim(draftClaimId, policyNumber, dateOfLoss, sourceSystem, preferredLanguage, vehiclePolicySystemId, dwellingPolicySystemId) {
  const requestBody = {
    query: `
      mutation {
        createShellClaim(createShellClaimInput: 
          {
            draftClaimId:"${draftClaimId}",
            policyNumber:"${policyNumber}",
            dateOfLoss:"${dateOfLoss}",
            sourceSystem:"${sourceSystem}",
            preferredLanguage:"${preferredLanguage}",
            vehiclePolicySystemId: ${vehiclePolicySystemId ? `"${vehiclePolicySystemId}"` : null},
            dwellingPolicySystemId: ${dwellingPolicySystemId ? `"${dwellingPolicySystemId}"` : null}
          }
        )
        {claimId, gwClaimId, gwClaimNumber, policyAddress, isDuplicated}
      }`,
    queryName: 'create_shell_claim',
  };
  const response = await axios.post('/api', requestBody);
  const policyAddress = response.data?.data?.createShellClaim?.policyAddress;
  if (policyAddress) {
    window.sessionStorage.setItem('policyAddress', policyAddress);
    window.dispatchEvent(new StorageEvent('storage', { key: 'policyAddress' }));
  }
  return response.data;
}
